// © Microsoft Corporation. All rights reserved.

/**
 * Interface for defining property if this is network failure
 */
interface NetworkErrorInterface {
    isNetworkFailure: boolean;
}

/**
 * A network-related error.
 */
export type NetworkError = Error & NetworkErrorInterface;

/**
 * Extending error class to instrument if this is network failure
 */
export class ConfigFetchError extends Error implements NetworkErrorInterface {
    isNetworkFailure: boolean;

    constructor(message: string, isNetworkFailure: boolean) {
        super(message);
        this.isNetworkFailure = isNetworkFailure;
    }
}